<template>
  <div class="position-relative">
    <!-- Global loading overlay synced with child components -->
    <div v-if="isLoading" class="report-loading-overlay d-flex align-items-center justify-content-center">
      <div class="text-center">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
        <div class="mt-1">Loading report…</div>
      </div>
    </div>
    <b-tabs
      horizontal
      pills
      fill
      nav-class="report-folder-tabs-nav"
      v-model="activeTab"
    >
      <b-tab title="⚙️ Dashboard">
        <dashboard-graphs v-if="activeTab == 0" @loading="syncLoading"></dashboard-graphs>
      </b-tab>
      <b-tab title="📜 Task Report">
        <task-report v-if="activeTab == 1" @loading="syncLoading"></task-report>
      </b-tab>
      <b-tab title="👤 User Report">
        <user-report v-if="activeTab == 2" @loading="syncLoading"></user-report>
      </b-tab>

       <b-tab title="📝 Quality Review Stats">
          <review-stats v-if="activeTab == 3"> </review-stats>
        </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import DashboardGraphs from './DashboardGraphs.vue';
import TaskReport from './TaskReport.vue';
import UserReport from './UserReport.vue';
import ReviewStats from './Review-Stats/ReviewStats.vue';

export default {
  components: {
    DashboardGraphs,
    TaskReport,
    UserReport,
    ReviewStats
  },

  mounted() {},

  data() {
    return {
      activeTab: 0,
      isLoading: false,
      loadingCount: 0,
    };
  },

  methods: {
    // Children emit @loading with true/false; we aggregate to control overlay
    syncLoading(state) {
      if (state === true) {
        this.loadingCount += 1;
      } else if (state === false && this.loadingCount > 0) {
        this.loadingCount -= 1;
      }
      this.isLoading = this.loadingCount > 0;
    },
  },
};
</script>

<style scoped lang="scss">
.report-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255,255,255,0.85);
  z-index: 10;
}

</style>

<!-- Non-scoped so it reliably reaches the nav that <b-tabs> renders; namespaced by
     .report-folder-tabs-nav so it cannot leak to other tab groups. -->
<style lang="scss">
.report-folder-tabs-nav.nav-pills {
  margin-bottom: 1rem;

  .nav-item {
    margin-right: 8px;
  }

  .nav-link {
    font-size: 1.2rem;
    font-weight: 700;
    padding: 0.8rem 1.5rem;
    color: #5a5c69 !important;
    background-color: transparent !important;
    border: 2px solid #008bcc !important;
    border-radius: 50rem !important;
    box-shadow: none !important;
    transition: all 0.15s ease-in-out;
  }

  .nav-link:hover:not(.active) {
    background-color: #c5d3e0 !important;
    color: #008bcc !important;
  }

  .nav-link.active {
    color: #fff !important;
    background-color: #008bcc !important;
    border-color: #008bcc !important;
    box-shadow: 0 2px 8px rgba(0, 139, 204, 0.25) !important;
  }
}

@media (max-width: 767px) {
  .report-folder-tabs-nav.nav-pills .nav-link {
    font-size: 0.95rem;
    padding: 0.55rem 0.7rem;
  }
}
</style>
